
module.exports = {
    serverUrl: `https://www.seoulbiohub.kr`,
    serverPrefixUrl: '/tree',
    loginMaintainenceTime: 10800,
    excuteAlarmTime : 300,
}